(function () {
	angular
		.module('trackeye')
		.factory('SutMessage', _SutMessageFactory);

	_SutMessageFactory.$inject = ['C4ApiService', '$q', '$translate'];

	function _SutMessageFactory(api, $q, $translate) {
		function SutMessage(data, collectionId) {
			this.id = undefined;
			this.ts = undefined;
			this.unit = undefined;
			this.message = undefined;
			this.href = undefined;
			this.gprs = undefined;
			this.gps = undefined;
			this.consumption = undefined;
			this.cap = undefined;
			this.address = undefined;
			this.echo = undefined;
			this.capacityRemaining = undefined;
			this.i2c = undefined;

			this.collectionId = undefined;
			this.addressResolved = false;

			this.delay_threshold = 300;

			this.triangulated = {
				active: false,
				fetched: false,
				data: {
					location: {},
					address: ""
				}
			};

			if (data !== undefined) {
				this.populate(data, collectionId);
			}
		}

		/**
		 * Get sutmessage id
		 * @returns {string}
		 */
		SutMessage.prototype.getId = function () {
			return this.id;
		};

		/**
		 * Get nodeid of the device
		 * @returns {string}
		 */
		SutMessage.prototype.getNodeId = function () {
			return this.unit.number;
		};

		/**
		 *
		 * @returns {Array}
		 */
		SutMessage.prototype.getCoord = function () {
			return [this.getLon(), this.getLat(), this.getRadius()];
		};

		SutMessage.prototype.hasCapacityPercentage = function () {
			return !!(this.consumption && this.consumption.capacityPercentage);
		};

		SutMessage.prototype.hasCapacityState = function () {
			return !!(this.consumption && this.consumption.capacityState);
		}

		SutMessage.prototype.hasCapacity = function () {
			if (!this.message)
				return false;

			return (
				!!this.cap ||
				!!this.message.bat
			);
		};

		SutMessage.prototype.hasCapacityBatValues = function () {
			return !isNaN(this.getBatteryCapacity());
		}

		/**
		 * Return capacity from vstart property
		 * @returns {number|undefined}
		 */
		SutMessage.prototype.getCapVstart = function () {
			if (!this.cap)
				return undefined;

			return (this.cap.vstart > 0) ? this.cap.vstart : undefined;
		};

		/**
		 * Return capacity from bat property
		 * @returns {number|undefined}
		 */
		SutMessage.prototype.getBat = function () {
			return (this.message.bat > 0) ? this.message.bat : undefined;
		};

		/**
		 * Return the battery capacity from either vstart or bat property
		 * @returns {number|undefined}
		 */
		SutMessage.prototype.getBatteryCapacity = function () {
			return this.hasCapacity() ? (this.getBat() || this.getCapVstart()) : undefined;
		};

		/**
		 * Return the battery percentage
		 * @param {string} suffix - Append given string, to returned value.
		 * @return {string|null}
		 */
		SutMessage.prototype.getBatteryPercentage = function (suffix) {
			if (!this.hasCapacityPercentage())
				return null;

			var battery = this.consumption.capacityPercentage >= 0 ? this.consumption.capacityPercentage : 0;
			return battery + suffix;
		};

		SutMessage.prototype.getBatteryState = function () {
			if (!this.hasCapacityState()) return null;

			switch (this.consumption.capacityState) {
				case 'optimal': {
					return {
						icon: 'fas fa-battery-empty',
						colorClass: 'bat-optimal',
						title: $translate.instant('STR_BATTERY_STATE_OPTIMAL')
					}
				}
				case 'warning': {
					return {
						icon: 'fas fa-battery-empty',
						colorClass: 'bat-warning',
						title: $translate.instant('STR_BATTERY_STATE_WARNING')
					}
				}
				case 'critical': {
					return {
						icon: 'fas fa-battery-exclamation',
						colorClass: 'bat-critical',
						title: $translate.instant('STR_BATTERY_STATE_CRITICAL')
					}
				}
			}
		}

		SutMessage.prototype.hasInitialBatteryPercentage = function() {
			return !!this.capacityRemaining
		}
		SutMessage.prototype.getInitialBatteryPercentage = function (suffix) {
			if (!this.hasInitialBatteryPercentage())
				return null;

			var battery = this.capacityRemaining >= 0 ? this.capacityRemaining : 0;
			return battery + suffix;
		};

		SutMessage.prototype.setInitialBatCapacity = function (value) {
			this.capacityRemaining = parseInt(value, 10);
		};

		SutMessage.prototype.unsetInitialBatteryPercentage = function () {
			this.capacityRemaining = undefined;
		}

		/**
		 * Return temperature
		 * @returns {number|undefined}
		 */
		SutMessage.prototype.getTemperature = function () {
			return !this.message ? undefined : this.message.temperature;
		};

		/**
		 * Return humidity
		 * @returns {number|undefined}
		 */
		SutMessage.prototype.getHumidity = function () {
			return !this.i2c || !this.i2c.humidity ? undefined : this.i2c.humidity;
		}

		/**
		 * Return humidity
		 * @returns {number|undefined}
		 */
		SutMessage.prototype.getI2CTemperature = function () {
			return !this.i2c || !this.i2c.temperature ? undefined : this.i2c.temperature;
		}

		SutMessage.prototype.getHourValue = function (input) {
			if (!this.message || !this.message.hourValue) {
				return 0
			}

			var parts = this.message.hourValue.split(',')
			return parts ? parseInt(parts[input-1]) : 0;
		}

		function minsToHHMM(mins) {
			var fract = (mins / 60).toString().split('.'),
				fractOr0 = fract[1] || 0,
				deciMinutes = parseFloat('.'+ fractOr0),
				minutes = Math.round(deciMinutes * 60);

			return [
				fract[0],
				minutes = (minutes <= 9) ? ('0' + minutes).toString() : minutes.toString()
			]
		}

		SutMessage.prototype.getHourValueI1 = function () {
			return minsToHHMM(this.getHourValue(1));
		}

		SutMessage.prototype.getHourValueI2 = function () {
			return minsToHHMM(this.getHourValue(2));
		}

		SutMessage.prototype.hasTemperature = function () {
			if (!this.message)
				return false;

			return angular.isDefined(this.message.temperature);
		};

		SutMessage.prototype.hasHumidity = function () {
			if (!this.i2c)
				return false;

			return angular.isDefined(this.i2c.humidity);
		}

		SutMessage.prototype.hasI2CTemperature = function () {
			if (!this.i2c)
				return false;

			return angular.isDefined(this.i2c.temperature);
		}

				/**
		 * Get longitude
		 * @param {number} [round_to] - Round to N decimals
		 * @return {undefined|string}
		 */
		SutMessage.prototype.getLon = function (round_to) {
			var _lon = this.gps ? this.gps.longitude : undefined;
			if (this.isTriangulationActive()) {
				_lon = this.getTriangulatedLon();
			}

			if (!_lon)
				return undefined;

			if (round_to >= 0) {
				return parseFloat(_lon).toFixed(round_to);
			}
			return _lon;
		};

		/**
		 * Get latitude
		 * @param {number} [round_to] - Round to N decimals
		 * @return {undefined|string}
		 */
		SutMessage.prototype.getLat = function (round_to) {
			var _lat = this.gps ? this.gps.latitude : undefined;
			if (this.isTriangulationActive()) {
				_lat = this.getTriangulatedLat();
			}

			if (!_lat)
				return undefined;

			if (round_to >= 0)
				return parseFloat(_lat).toFixed(round_to);

			return _lat;
		};

		/**
		 *
		 * @returns {Number}
		 */
		SutMessage.prototype.getRadius = function () {
			if (this.isTriangulationActive())
				return this.getTriangulatedRadius();

			if (!this.gps)
				return 0;

			if (this.gps.radius == undefined)
				return 0;

			return parseInt(this.gps.radius, 10);
		};

		/**
		 * Asserts if the message has longitude or latitude
		 * @returns {boolean}
		 */
		SutMessage.prototype.hasLonLat = function () {
			return (
				angular.isDefined(this.getLon()) ||
				angular.isDefined(this.getLat())
			) && (
				this.getLon() !== 0 ||
				this.getLat() !== 0
			);
		};

		/**
		 * Check if the position is GPS, by checking if radius field is set,
		 * and the value is 0
		 *
		 * @return {boolean}
		 */
		SutMessage.prototype.isGPS = function () {
			return (this.hasLonLat() && !this.getRadius());
		};

		/**
		 * Check if the position is GSM, by checking if radius field is set,
		 * and the value is not 0
		 *
		 * @return {boolean}
		 */
		SutMessage.prototype.isGSM = function () {
			return (this.hasLonLat() && this.getRadius() > 0);
		};

		/**
		 * Asserts if a report is delayed, by checking if the difference
		 * between the server ts and device ts, exceeds a given threshold
		 *
		 * @return {boolean}
		 */
		SutMessage.prototype.isDelayed = function () {
			var device_ts = this.getDeviceTs(),
				diff_ts = this.getServerTsEpoch() - device_ts;

			return ((diff_ts > (this.getDelayThreshold() * 1000)) && device_ts);
		};

		/**
		 * Returns threshold for marked messages as delayed.
		 * @returns {number}
		 */
		SutMessage.prototype.getDelayThreshold = function () {
			return this.delay_threshold;
		};

		/**
		 * Returns how much the message is delayed in seconds
		 * @returns {number}
		 */
		SutMessage.prototype.getSecondsDelayed = function () {
			if (!this.isDelayed())
				return 0;

			return (this.getServerTsEpoch() - this.getDeviceTs()) / 1000;
		};

		/**
		 * Returns how much the message is delayed in minutes
		 * @returns {number}
		 */
		SutMessage.prototype.getMinutesDelayed = function () {
			return Math.round(this.getSecondsDelayed() / 60);
		};

		/**
		 * Asserts if the message has a location,
		 * @return {boolean}
		 */
		SutMessage.prototype.hasLocation = function () {
			return this.hasLonLat();
		};

		/**
		 * Is true, if the instance has the id property set.
		 * @return {boolean}
		 */
		SutMessage.prototype.isPopulated = function () {
			return !!this.id;
		};

		/**
		 * Unit state methods
		 */

		SutMessage.prototype.isByAlarm1 = function () {
			return false;
		};

		SutMessage.prototype.isByAlarm2 = function () {
			return false;
		};

		SutMessage.prototype.isByEchoHeard = function () {
			return (this.echo.number && this.echo.connected);
		};

		SutMessage.prototype.isByEchoLost = function () {
			return (this.echo.number && !this.echo.connected);
		};

		SutMessage.prototype.isByLight = function () {
			return this.isStatemaskBitSet(35);
		};

		SutMessage.prototype.isByMoving = function () {
			return this.isStatemaskBitSet(30);
		};

		SutMessage.prototype.isByCustomTime = function () {
			return false;
		};

		SutMessage.prototype.isLastGood = function () {
			return this.isStatemaskBitSet(8);
		};

		SutMessage.prototype.isByTamper = function () {
			return this.isStatemaskBitSet(17);
		};

		SutMessage.prototype.isByTurnSignal = function () {
			return this.isStatemaskBitSet(16);
		};

		SutMessage.prototype.isByBrake = function () {
			return this.isStatemaskBitSet(17);
		};

		SutMessage.prototype.isByHeadlight = function () {
			return (
				this.isStatemaskBitSet(1) &&
				!this.isStatemaskBitSet(16) &&
				!this.isStatemaskBitSet(17)
			);
		};

		SutMessage.prototype.isByActive = function () {
			return (
				this.isStatemaskBitSet(16) &&
				this.isStatemaskBitSet(34)
			);
		}

		SutMessage.prototype.isByInput2High = function () {
			return this.isStatemaskBitSet(17);
		}

		SutMessage.prototype.isCharging = function () {
			return this.isStatemaskBitSet(1) && !this.isStatemaskBitSet(0);
		};

		SutMessage.prototype.isChargeCompleted = function () {
			return this.isStatemaskBitSet(1) && this.isStatemaskBitSet(0);
		};

		SutMessage.prototype.isChargerConnected = function () {
			return !this.isStatemaskBitSet(1) && this.isStatemaskBitSet(0)
		};

		SutMessage.prototype.isBeaconActive = function () {
			return this.isStatemaskBitSet(29);
		};

		/**
		 * Asserts if a passed bit, is set in the device statemask.
		 *
		 * @param  {number} [bit=2] - Bit of statemask
		 * @return {boolean}
		 */
		SutMessage.prototype.isStatemaskBitSet = function (bit) {
			return !this.unit ? false : !!(Math.floor(parseInt(this.unit.state,16) / Math.pow(2, bit)) & (1 << 0));
		};

		/**
		 * Get echo number
		 * @return {Number}
		 */
		SutMessage.prototype.getEchoNumber = function () {
			return this.echo.number;
		};

		/**
		 * Get the date string
		 *
		 * @return {string} - ISO8601-formatted date string
		 */
		SutMessage.prototype.getTs = function () {
			return this.getCorrectTime();
		};

		/**
		 * Get date string, with timezone
		 */
		SutMessage.prototype.getTsWithTimezone = function () {
			if (this.isTriangulationActive())
				return moment(this.getGpsTs()).format();

			if (!this.getTs())
				return undefined;

			return moment(this.getTs()).format();
		};

		/**
		 * Get the unix epoch time.
		 *
		 * @return {number} - Seconds (incl. miliseconds) since unix epoch
		 */
		SutMessage.prototype.getTime = function () {
			var date = new Date(this.getCorrectTime());
			return date.getTime();
		};

		/**
		 * Get server timestamp as unix epoch time.
		 *
		 * @return {number} - Seconds (incl. miliseconds) since unix epoch
		 */
		SutMessage.prototype.getServerTsEpoch = function () {
			return (new Date(this.ts)).getTime();
		};

		/**
		 * Get server timestamp as unix epoch time.
		 *
		 * @return {number} - Seconds (incl. miliseconds) since unix epoch
		 */
		SutMessage.prototype.getServerTs = function () {
			return this.ts;
		};

		/**
		 * Get device timestamp as unix epoch time.
		 *
		 * @return {number} - Seconds (incl. miliseconds) since unix epoch
		 */
		SutMessage.prototype.getDeviceTs = function () {
			return (new Date(this.message.ts)).getTime() || 0;
		};

		/**
		 * Get GPS timestamp as unix epoch time.
		 * @return {Number|boolean} - Seconds (incl. miliseconds) since unix epoch
		 */
		SutMessage.prototype.getGpsTs = function () {
			if (this.gps) {
				return (new Date(this.gps.ts)).getTime() || false;
			}
			return false;
		};

		/**
		 * Returns the correct UTC time to use.
		 * If the deviceTime is not set, the serverTime will be used
		 * If the deviceTime > serverTime, the serverTime will be used
		 * otherwise the deviceTime will beused
		 *
		 * @return {string|null}
		 * @private
		 */
		SutMessage.prototype.getCorrectTime = function () {
			if (!this.ts && !this.message)
				return null;

			var serverTime = new Date(this.ts),
				deviceTime = this.message.ts ? new Date(this.message.ts) : undefined;

			if (!deviceTime)
				return this.ts;

			if (deviceTime.getTime() > serverTime.getTime())
				return this.ts;

			return this.message.ts;
		};

		/**
		 * Returns parsed meassured analogue values
		 * @returns {Object|bool}
		 */
		SutMessage.prototype.getMeassuredAna = function () {
			if (!this.message.ana)
				return false;

			var ana = this.message.ana.split(',');

			return {
				'input1': parseInt(ana[0], 10),
				'input2': parseInt(ana[1], 10)
			};
		};

		/**
		 * Get the meassured analogue value of port 1
		 * @returns {Number|bool}
		 */
		SutMessage.prototype.getAnaInput1 = function () {
			var ana = this.getMeassuredAna();

			return ana ? ana.input1 : ana;
		};

		/**
		 * Get the meassured analogue value of port 2
		 * @returns {Number|bool}
		 */
		SutMessage.prototype.getAnaInput2 = function () {
			var ana = this.getMeassuredAna();

			return ana ? ana.input2 : ana;
		};

		/**
		 * Returns the raw GSM part, for the sutmessage
		 * eg.: GSM[2,{238,1,1605,169,-87},{238,1,0,169,-100},{238,1,0,169,-100}]
		 * @returns {string};
		 */
		SutMessage.prototype.getRawGSM = function () {
			var blocks = this.gprs.map(function(cell) {
				var cell_block = [cell.mcc,cell.mnc,cell.cid,cell.lac,cell.rssi];
				return "{" + cell_block.join(',') + "}";
			});

			return "GSM["+this.message.ta+","+blocks.join(',')+"]";
		};

		/**
		 * Sets location and address, based on a triangulation lookup
		 * which is done manually by the client.
		 * @param {object} data
		 */
		SutMessage.prototype.setTriangulated = function (data) {
			this.triangulated.data.location = data.location;
			this.triangulated.data.address = data.address;
			this.triangulated.active = true;
			this.triangulated.fetched = true;

			return this;
		};

		SutMessage.prototype.getTriangulatedLon = function () {
			return this.triangulated.data.location.longitude;
		};

		SutMessage.prototype.getTriangulatedLat = function () {
			return this.triangulated.data.location.latitude;
		};

		SutMessage.prototype.getTriangulatedRadius = function () {
			return parseInt(this.triangulated.data.location.radius,10);
		};

		SutMessage.prototype.getTriangulatedAddress = function () {
			return this.triangulated.data.address;
		};

		/**
		 * Asserts if the triangulation request has been made.
		 * @returns {bool}
		 */
		SutMessage.prototype.isTriangulated = function () {
			return this.triangulated.fetched;
		};

		/**
		 * Asserts if the triangulation object i marked as active
		 * @returns {bool}
		 */
		SutMessage.prototype.isTriangulationActive = function () {
			return this.triangulated.active;
		};

		/**
		 * Marks the triangulation object as active, this has no effect on
		 * the SutMessage object. Just to indicate, which location data to use.
		 * @param {boolean} value
		 */
		SutMessage.prototype.setTriangulationActive = function (value) {
			return this.triangulated.active = value;
		};

		SutMessage.prototype.getAddress = function (keys, return_if_undef) {
			var objVal = this._traverseObjectByString(keys, this.address);

			if (angular.isDefined(return_if_undef)) {
				return objVal || return_if_undef;
			}

			return objVal;
		};

		SutMessage.prototype.getParsedAddress = function (max_length) {
			var addr_string = "";

			if (this.address) {
				if (this.address.country)
					addr_string += this.address.country + " -";

				if (this.address.town)
					addr_string += " " + this.address.town;

				if (this.isGPS()) {
					if (this.address.street.name)
						addr_string += ", " + this.address.street.name;

					if (this.address.street.building.number)
						addr_string += " " + this.address.street.building.number;
				}
			}

			addr_string = addr_string.trim();

			if (max_length) {
				if (addr_string.length > max_length)
					return addr_string.substr(0, max_length).trim() + "...";
			}

			return addr_string;
		};

		/**
		 * Populate the object, with data. Only declared
		 * properties will be added.
		 *
		 * @param  {Object} data
		 * @param {string} [collectionId]
		 */
		SutMessage.prototype.populate = function (data, collectionId) {
			this.setCollectionId(collectionId);

			for (var key in data) {
				if (this.hasOwnProperty(key)) {
					this[key] = data[key];
				}
			}
		};

		/**
		 * Fetch the nearest address from longitude and latitude
		 */
		SutMessage.prototype.fetchAddress = function (overrideQueueId) {
			var defer = $q.defer(),
				self = this;

			if (!self.gps) {
				self.addressResolved = true;
				defer.resolve();
			} else if (this.isAddressResolved()) {
				defer.resolve();
			} else {
				api.address(self.gps.latitude, self.gps.longitude, overrideQueueId || this.getCollectionId()).then(function (response)
				{
					if (response)
						self.address = response.data;
				}, angular.noop).finally(function () {
					self.addressResolved = true;
					defer.resolve();
				});
			}

			return defer.promise;
		};

		SutMessage.prototype.isAddressResolved = function () {
			return this.addressResolved;
		};

		/**
		 * Determines if the sutmessage is good, but asserting if the collectionid has been set.
		 * This prevents, show
		 * @returns {boolean}
		 */

		SutMessage.prototype.getCollectionId = function () {
			return this.collectionId;
		};

		SutMessage.prototype.setCollectionId = function (uuid) {
			this.collectionId = uuid;
		};

		SutMessage.prototype._traverseObjectByString = function (path, part) {
			var path_split = path.split("."),
				key = path_split.shift();

			if (part !== undefined) {
				if (path_split.length == 0)
					return part[key];

				if (part.hasOwnProperty(key))
					return this._traverseObjectByString(path_split.join("."), part[key]);
			}

			return undefined;
		};

		return SutMessage;
	}
})();
